/*
 * Zubehoer zum Anhaken auf der Produktseite (Block g24-addons).
 *
 * Ablauf beim Kauf: Der Submit des Produktformulars wird in der Capture-Phase
 * auf document abgefangen, also bevor product-form.js ihn sieht. Sind Haken
 * gesetzt, legen wir die Auswahl in EINEM Request per /cart/add.js ab und
 * schicken danach denselben Submit mit einer Markierung erneut ab. Den
 * Hauptartikel verarbeitet dann product-form.js wie immer: Drawer, das
 * Garantie-Popup bei Trolleys (get_preparation) und die Gratis-Artikel bleiben
 * unberuehrt. Weil das Zubehoer zuerst im Korb liegt, bringt die Antwort auf
 * den Hauptartikel den Drawer schon inklusive Zubehoer mit.
 *
 * Scheitert danach der Hauptartikel (on:cart:error, etwa zu wenig Bestand),
 * nehmen wir das eben hinzugefuegte Zubehoer wieder heraus. Sonst laege
 * Zubehoer ohne den Artikel im Korb, zu dem es gehoert.
 *
 * Requests laufen bewusst mit minimalem init (nur Content-Type und
 * X-Requested-With, kein Accept, kein AbortSignal): SellEasy und die
 * Event-Listener von Shopify patchen window.fetch und verlieren sonst den Body.
 *
 * Preise kommen in Cent und werden ueber Intl mit der aktiven Waehrung
 * formatiert, wie in g24-pdp.js.
 *
 * Kennzeichnung fuer die Auswertung, fuer Kunden unsichtbar:
 * - jede Position aus dem Modul traegt die Property _upsell: PDP. Properties
 *   mit Unterstrich blendet Shopify im Checkout aus, cart-items.liquid im
 *   Drawer und auf der Warenkorbseite ebenfalls. Im Admin steht sie an der
 *   Bestellposition.
 * - die Bestellung bekommt das Attribut _upsell_pdp mit den Artikelnamen
 *   (Admin: Zusaetzliche Details, Bestell-Export: Note Attributes). Gesetzt
 *   wird es erst, wenn der Hauptartikel im Korb liegt.
 */
(() => {
  if (window.g24PdpAddons) return;
  window.g24PdpAddons = true;

  const waehrung = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  let format = null;
  try {
    format = new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung });
  } catch (e) {
    format = null;
  }
  const geld = (cent) => (format
    ? format.format(cent / 100)
    : `${(cent / 100).toFixed(2).replace('.', ',')} €`);

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Texte kommen je Sprache aus data-g24-addons-i18n (g24-pdp-addons.liquid).
  // Die deutschen Werte hier sind nur der Rueckfall, falls das Attribut fehlt.
  const STANDARD = {
    total: 'Gesamt für [count] Artikel',
    from: 'ab',
    chooseVariant: 'Bitte wählen Sie beim Zubehör noch eine Variante aus.',
    addFailed: 'Das Zubehör konnte gerade nicht hinzugefügt werden. Der Artikel selbst kommt trotzdem in den Warenkorb.',
    addedOne: 'Das Zubehör liegt mit im Warenkorb.',
    addedOther: '[count] Zubehörteile liegen mit im Warenkorb.',
    removed: 'Das Zubehör wurde wieder entfernt, weil der Artikel nicht in den Warenkorb gelegt werden konnte.',
    unavailable: 'Diese Variante ist gerade nicht lieferbar.'
  };
  // Shopify maskiert Uebersetzungen ohne _html (z.B. ' als &#39;).
  const entschluesseln = (s) => {
    const el = document.createElement('textarea');
    el.innerHTML = s;
    return el.value;
  };
  const text = (box, schluessel, anzahl) => {
    if (!box.g24Texte) {
      let geladen = {};
      try {
        geladen = JSON.parse(box.dataset.g24AddonsI18n || '{}') || {};
      } catch (e) {
        geladen = {};
      }
      box.g24Texte = geladen;
    }
    const roh = box.g24Texte[schluessel] || STANDARD[schluessel] || '';
    const wert = entschluesseln(roh);
    return anzahl === undefined ? wert : wert.replace('[count]', anzahl);
  };

  const post = async (pfad, body) => {
    const res = await fetch(`${root}${pfad}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || String(res.status));
    return data;
  };

  // Laufender Kauf: welches Formular, welche Zeilen wir hinzugefuegt haben.
  let offen = null;

  const formFuer = (box) => document.getElementById(box.dataset.formId);
  // Bewusst getAttribute: Das Produktformular hat ein Feld name="id", und
  // form.id liefert dann dieses Feld statt der Formular-ID.
  const boxFuer = (form) => {
    const id = form && form.getAttribute && form.getAttribute('id');
    if (!id) return null;
    return document.querySelector(`[data-g24-addons][data-form-id="${CSS.escape(id)}"]`);
  };

  const zustand = (item) => {
    const check = item.querySelector('[data-g24-addon-check]');
    const select = item.querySelector('[data-g24-addon-select]');
    let variantId = item.dataset.variantId || '';
    let preis = Number(item.dataset.price || 0);
    let vergleich = 0;
    if (select && select.value) {
      const opt = select.options[select.selectedIndex];
      variantId = select.value;
      preis = Number(opt.dataset.price || 0);
      vergleich = Number(opt.dataset.compare || 0);
    }
    return { item, check, select, variantId, preis, vergleich, gewaehlt: check.checked };
  };

  const gewaehlte = (box) => [...box.querySelectorAll('[data-g24-addon]')]
    .map(zustand)
    .filter((z) => z.gewaehlt);

  const menge = (box) => {
    const form = formFuer(box);
    const feld = form && form.querySelector('[name="quantity"]');
    const wert = feld ? parseInt(feld.value, 10) : 1;
    return Number.isFinite(wert) && wert > 0 ? wert : 1;
  };

  const meldung = (box, text, art) => {
    const el = box.querySelector('[data-g24-addons-msg]');
    if (!el) return;
    clearTimeout(el.g24Timer);
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('is-error', art === 'fehler');
    el.classList.toggle('is-success', art === 'ok');
    if (text && art === 'ok') {
      el.g24Timer = setTimeout(() => { el.hidden = true; }, 6000);
    }
  };

  const hinweis = (z, an) => {
    const el = z.item.querySelector('[data-g24-addon-hint]');
    if (el) el.hidden = !an;
    z.item.classList.toggle('needs-variant', an);
  };

  const aktualisieren = (box) => {
    const alle = [...box.querySelectorAll('[data-g24-addon]')].map(zustand);
    let anzahl = 0;
    let summe = 0;

    alle.forEach((z) => {
      z.item.classList.toggle('is-selected', z.gewaehlt);
      if (z.gewaehlt) {
        anzahl += 1;
        summe += z.preis;
      }
      if (z.select && z.select.value) {
        const preisEl = z.item.querySelector('[data-g24-addon-price]');
        const altEl = z.item.querySelector('[data-g24-addon-compare]');
        const sale = z.vergleich > z.preis;
        if (preisEl) preisEl.textContent = `+ ${geld(z.preis)}`;
        if (altEl) {
          altEl.textContent = sale ? geld(z.vergleich) : '';
          altEl.hidden = !sale;
        }
        preisEl && preisEl.parentElement.classList.toggle('is-sale', sale);
      }
    });

    const footer = box.querySelector('[data-g24-addons-footer]');
    const offenVorher = footer.classList.contains('is-open');
    footer.classList.toggle('is-open', anzahl > 0);
    if (anzahl > 0 && !offenVorher) footer.classList.add('is-entering');

    const stueck = menge(box);
    const haupt = Number(box.dataset.mainPrice || 0) * stueck;
    const unvollstaendig = alle.some((z) => z.gewaehlt && !z.variantId);
    box.querySelector('[data-g24-addons-summary]').textContent = text(box, 'total', stueck + anzahl);
    box.querySelector('[data-g24-addons-total]').textContent = unvollstaendig
      ? `${text(box, 'from')} ${geld(haupt + summe)}`
      : geld(haupt + summe);

    const cta = box.querySelector('[data-g24-addons-cta]');
    cta.disabled = box.dataset.mainAvailable !== 'true';
  };

  const zuruecksetzen = (box) => {
    box.querySelectorAll('[data-g24-addon-check]').forEach((c) => { c.checked = false; });
    box.querySelectorAll('[data-g24-addon]').forEach((item) => hinweis(zustand(item), false));
    aktualisieren(box);
  };

  const beschaeftigt = (box, an) => {
    box.classList.toggle('is-busy', an);
    const cta = box.querySelector('[data-g24-addons-cta]');
    if (cta) cta.classList.toggle('is-loading', an);
  };

  // Eben hinzugefuegtes Zubehoer wieder herausnehmen, wenn der Hauptartikel
  // nicht im Korb gelandet ist. Liegt er drin, bleibt das Zubehoer: Shopify
  // meldet z.B. bei zu grosser Menge 422, legt aber die lieferbaren Stueck
  // trotzdem in den Korb. Liefert { entfernt, cart }.
  const aufraeumen = async (zeilen, hauptId) => {
    try {
      const res = await fetch(`${root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const cart = await res.json();
      if (hauptId && cart.items.some((i) => String(i.variant_id) === String(hauptId))) {
        return { entfernt: false, cart };
      }
      const updates = {};
      zeilen.forEach(({ key, qty }) => {
        const line = cart.items.find((i) => i.key === key);
        if (line) updates[key] = Math.max(0, line.quantity - qty);
      });
      if (!Object.keys(updates).length) return { entfernt: false, cart };
      await post('cart/update.js', { updates });
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      return { entfernt: true, cart };
    } catch (e) {
      console.warn('g24-addons: Zubehoer konnte nicht geprueft werden', e); // eslint-disable-line
      return { entfernt: false, cart: null };
    }
  };

  // Bestell-Attribut setzen. Kommt der Kunde mehrfach ueber das Modul,
  // werden die Namen angehaengt statt ueberschrieben.
  const markieren = (namen, cart) => {
    const bisher = cart && cart.attributes && cart.attributes._upsell_pdp;
    const wert = [bisher, namen.join(', ')].filter(Boolean).join('; ');
    post('cart/update.js', { attributes: { _upsell_pdp: wert } }).catch(() => {});
  };

  const tracken = (liste) => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: 'g24_pdp_addons_add',
      g24_addons: liste.map((z) => ({
        variant_id: z.variantId,
        title: z.item.dataset.title,
        price: z.preis / 100
      }))
    });
  };

  // --- Submit des Produktformulars abfangen -------------------------------
  document.addEventListener('submit', async (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    const box = boxFuer(form);
    if (!box) return;

    if (form.dataset.g24AddonsPass === '1') {
      delete form.dataset.g24AddonsPass;
      return;
    }

    if (box.classList.contains('is-busy')) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }

    const liste = gewaehlte(box);
    if (!liste.length) return;

    const fehlt = liste.find((z) => !z.variantId);
    if (fehlt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      hinweis(fehlt, true);
      meldung(box, text(box, 'chooseVariant'), 'fehler');
      fehlt.select.focus();
      fehlt.item.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    const btn = form.querySelector('[name="add"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();
    meldung(box, '');
    beschaeftigt(box, true);
    if (btn) btn.classList.add('is-loading');

    try {
      const antwort = await post('cart/add.js', {
        items: liste.map((z) => ({
          id: Number(z.variantId),
          quantity: 1,
          properties: { _upsell: 'PDP' }
        }))
      });
      const hauptFeld = form.querySelector('[name="id"]');
      offen = {
        form,
        box,
        hauptId: hauptFeld ? hauptFeld.value : '',
        anzahl: liste.length,
        namen: liste.map((z) => {
          const opt = z.select && z.select.options[z.select.selectedIndex];
          const variante = opt ? opt.text.split(' · ')[0].trim() : '';
          return variante ? `${z.item.dataset.title} (${variante})` : z.item.dataset.title;
        }),
        zeilen: (antwort.items || []).map((i) => ({ key: i.key, qty: 1 })),
        bis: Date.now() + 20000
      };
      tracken(liste);
    } catch (e) {
      offen = null;
      meldung(box, text(box, 'addFailed'), 'fehler');
    } finally {
      beschaeftigt(box, false);
    }

    form.dataset.g24AddonsPass = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn || undefined);
    } else if (btn) {
      btn.click();
    } else {
      form.submit();
    }
  }, true);

  // --- Ergebnis des Hauptartikels ---------------------------------------
  const gehoertDazu = (evt) => offen
    && Date.now() < offen.bis
    && evt.target instanceof Element
    && evt.target.contains(offen.form);

  const erfolg = (evt) => {
    if (!gehoertDazu(evt)) return;
    const { box, anzahl, namen } = offen;
    offen = null;
    markieren(namen, evt.detail && evt.detail.cart);
    zuruecksetzen(box);
    meldung(
      box,
      anzahl === 1 ? text(box, 'addedOne') : text(box, 'addedOther', anzahl),
      'ok'
    );
  };

  document.addEventListener('on:cart:add', erfolg);
  document.addEventListener('on:line-item:change', erfolg);
  document.addEventListener('on:cart:error', async (evt) => {
    if (!gehoertDazu(evt)) return;
    const { box, zeilen, hauptId, namen } = offen;
    offen = null;
    const { entfernt, cart } = await aufraeumen(zeilen, hauptId);
    if (entfernt) {
      meldung(box, text(box, 'removed'), 'fehler');
    } else if (cart) {
      // Hauptartikel liegt trotz Fehler im Korb (Teilmenge), Zubehoer bleibt.
      markieren(namen, cart);
    }
  });

  // --- Bedienung im Modul ------------------------------------------------
  const init = (box) => {
    if (box.dataset.g24Ready) return;
    box.dataset.g24Ready = '1';

    box.addEventListener('change', (evt) => {
      const item = evt.target.closest('[data-g24-addon]');
      if (!item) return;
      const z = zustand(item);

      if (evt.target.matches('[data-g24-addon-check]')) {
        if (z.gewaehlt && z.select && !z.select.value) {
          hinweis(z, true);
          z.select.focus();
        } else if (!z.gewaehlt) {
          hinweis(z, false);
        }
      }

      if (evt.target.matches('[data-g24-addon-select]')) {
        // Wer eine Variante waehlt, will den Artikel haben.
        if (z.select.value) {
          z.check.checked = true;
          hinweis(z, false);
        }
      }

      meldung(box, '');
      aktualisieren(box);
    });

    box.querySelector('[data-g24-addons-cta]').addEventListener('click', () => {
      const form = formFuer(box);
      const btn = form && form.querySelector('[name="add"]');
      if (!form || !btn || btn.disabled) {
        meldung(box, text(box, 'unavailable'), 'fehler');
        return;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
      else btn.click();
    });

    const footer = box.querySelector('[data-g24-addons-footer]');
    footer.addEventListener('animationend', () => footer.classList.remove('is-entering'));

    aktualisieren(box);
  };

  // Variantenwechsel am Hauptartikel: Preis und Lieferbarkeit nachziehen.
  // variant-picker.js liefert in detail.form das Produktformular mit.
  document.addEventListener('on:variant:change', (evt) => {
    const box = boxFuer(evt.detail && evt.detail.form);
    if (!box) return;
    const variante = evt.detail.variant;
    box.dataset.mainPrice = variante ? variante.price : box.dataset.mainPrice;
    box.dataset.mainAvailable = String(!!(variante && variante.available));
    aktualisieren(box);
  });

  // Menge am Hauptartikel geaendert: Summe nachziehen.
  const mengeGeaendert = (evt) => {
    if (!evt.target.matches || !evt.target.matches('[name="quantity"]')) return;
    const box = boxFuer(evt.target.form);
    if (box) aktualisieren(box);
  };
  document.addEventListener('change', mengeGeaendert);
  document.addEventListener('input', mengeGeaendert);

  const start = () => document.querySelectorAll('[data-g24-addons]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
